import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { MinimalPageLayout } from '../components/Navigation/MinimalLayout/MinimalPageLayout';
import { StayInContactIcon } from '../components/Shared/StayInContactIcon';
import { SupportDashboard } from '../components/Support/SupportDashboard';

export function SupportPage() {
    const { classes } = useStyles();

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <SupportDashboard />
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    icon: {
        maxWidth: '250px',
    },
}));
